var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"display-1 pl-5",staticStyle:{"border-bottom":"#ffca37 2px solid"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }